module.exports = __webpack_public_path__ + "static/media/proj17_img4.844d648b.jpg";